export default "__VITE_ASSET__YuRBUdCf__"